// Mirrors BILLING_TRANSACTION_TYPES in the API's constants/billingTransaction.ts.
export const BILLING_TRANSACTION_TYPES = [
  "PAYMENT",
  "COD_CONTRA",
  "CREDIT_NOTE_APPLICATION",
  "DEBIT_NOTE_APPLICATION",
  "GATEWAY_INTENT",
];

export const BILLING_TRANSACTION_TYPE_COLORS = {
  PAYMENT: "green",
  COD_CONTRA: "blue",
  CREDIT_NOTE_APPLICATION: "purple",
  DEBIT_NOTE_APPLICATION: "orange",
  GATEWAY_INTENT: "gold",
};

// Mirrors BILLING_TRANSACTION_STATUSES -- only set on GATEWAY_INTENT rows, every other type is
// written already-settled and has no status.
export const BILLING_TRANSACTION_STATUS_COLORS = {
  PENDING: "gold",
  CONFIRMED: "green",
  FAILED: "red",
};
